import {
  Paragraph,
  PositionalTab,
  PositionalTabAlignment,
  PositionalTabLeader,
  PositionalTabRelativeTo,
  Tab,
  Table,
  TableCell,
  TableRow,
  TabStopPosition,
  TabStopType,
  TextRun,
  WidthType,
  convertInchesToTwip,
} from "docx";
import { getDateObjectLocal } from "../../../helpers/Date";
import { paragraphArial } from "../results/paragraphs";

export const tablines1 = () => {
  return new Paragraph({
    children: [
      new TextRun({
        children: ["Multiple ", new Tab(), "tab ", new Tab(), "stops!"],
      }),
    ],
    tabStops: [
      {
        type: TabStopType.RIGHT,
        position: TabStopPosition.MAX,
      },
      {
        type: TabStopType.RIGHT,
        position: 1000,
      },
    ],
  });
};
export const tablines2 = () => {
  return new Paragraph({
    children: [
      new TextRun("Full name"),
      new TextRun({
        children: [
          new PositionalTab({
            alignment: PositionalTabAlignment.LEFT,
            relativeTo: PositionalTabRelativeTo.MARGIN,
            leader: PositionalTabLeader.UNDERSCORE,
          }),
          "diddi",
          new PositionalTab({
            alignment: PositionalTabAlignment.CENTER,
            relativeTo: PositionalTabRelativeTo.MARGIN,
            leader: PositionalTabLeader.UNDERSCORE,
          }),
          "John Doe",
        ],
        bold: true,
      }),
    ],
  });
};
export const tablines3 = () => {
  return new Paragraph({
    children: [new TextRun("Kurs:\t"), new TextRun("Jahrgang:\t")],
    tabStops: [
      {
        type: TabStopType.RIGHT,
        position: 3000,
        leader: "underscore",
      },
      {
        type: TabStopType.RIGHT,
        position: TabStopPosition.MAX,
        leader: "underscore",
      },
    ],
  });
};
export const tablineWithOneTab = (text1) => {
  return new Paragraph({
    spacing: { before: 100 },
    children: [new TextRun({ text: text1, font: "arial" })],
    tabStops: [
      {
        type: TabStopType.RIGHT,
        position: 6000,
        leader: "underscore",
        bold: true,
      },
    ],
  });
};
export const tablineWithTwoTabs = (text1, text2) => {
  return new Paragraph({
    children: [
      new TextRun({ text: text1, font: "arial" }),
      new TextRun({ text: text2, font: "arial" }),
    ],
    tabStops: [
      {
        type: TabStopType.RIGHT,
        position: 6000,
        leader: "underscore",
        bold: true,
      },
      {
        type: TabStopType.RIGHT,
        position: TabStopPosition.MAX,
        leader: "underscore",
        bold: true,
      },
    ],
  });
};
export const firstThreeLines = () => {
  return [
    new Paragraph(""),
    tablineWithTwoTabs("Kurs:\t", "Jahrgang:\t"),
    new Paragraph(""),
    tablineWithTwoTabs("Datum der Klausur:\t", ""),
    new Paragraph(""),
    tablineWithTwoTabs(
      "Schülerinnen und Schüler im Kurs:\t",
      "Klausur versäumt:\t"
    ),
    new Paragraph(""),
    tablineWithTwoTabs("Notenspiegel"),
    new Paragraph(""),
  ];
};

export const secondThreeLines = () => {
  return [
    new Paragraph(""),
    tablineWithTwoTabs("1.\t", "erreichte Punkte/Note:\t"),
    new Paragraph(""),
    tablineWithTwoTabs("2.\t", "erreichte Punkte/Note:\t"),
    new Paragraph(""),
    tablineWithTwoTabs("3.\t", "erreichte Punkte/Note:\t"),
    new Paragraph(""),
    new Paragraph(""),
  ];
};

export const tablineDate = (user, klausur, companies) => {
  const city = companies.find(
    (c) => c.id === parseInt(klausur.companyId)
  )?.city;
  return new Paragraph({
    children: [
      new TextRun({
        text: `${city}, den ${getDateObjectLocal(new Date()).short}\t`,
        font: "arial",
      }),
      new TextRun({
        text: `${user.firstName} ${user.lastName} `,
        font: "arial",
      }),
    ],
    tabStops: [
      {
        type: TabStopType.RIGHT,
        position: TabStopPosition.MAX,
        leader: "underscore",
        bold: true,
      },
    ],
  });
};

export const tableField = () => {
  return new Table({
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            margins: {
              top: convertInchesToTwip(0.05),
              bottom: convertInchesToTwip(0.05),
              left: convertInchesToTwip(0.05),
              right: convertInchesToTwip(0.05),
            },
            children: [
              new Paragraph({
                spacing: { before: 250 },

                tabStops: [
                  {
                    type: TabStopType.RIGHT,
                    position: 8000,
                    leader: "underscore",
                    bold: true,
                  },
                ],

                children: [
                  new TextRun({
                    font: "arial",
                    text: "Geprüft durch (Name, Funktion):\t",
                  }),
                ],
              }),

              // tablineWithOneTab("Geprüft durch (Name, Funktion)\t"),

              new Paragraph(""),
              paragraphArial("Bemerkungen"),

              new Paragraph({
                spacing: { before: 2000 },
                children: [
                  new TextRun({ text: "Berlin, den\t", font: "arial" }),
                  new TextRun({ text: "  \t", font: "arial" }),
                ],
                tabStops: [
                  {
                    type: TabStopType.RIGHT,
                    position: 4500,
                    leader: "underscore",
                    bold: true,
                  },
                  {
                    type: TabStopType.RIGHT,
                    position: 8000,
                    leader: "underscore",
                    bold: true,
                  },
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: "\t(Unterschrift)",
                    font: "arial",
                  }),
                ],
                tabStops: [
                  {
                    type: TabStopType.RIGHT,
                    position: 6500,

                    bold: true,
                  },
                ],
              }),
              new Paragraph(""),
            ],
          }),
        ],
      }),
    ],
  });
};
export const tabSignatureLine = (text1, text2) => {
  return new Paragraph({
    children: [
      new TextRun({ text: text1, font: "arial" }),
      new TextRun({ text: text2, font: "arial" }),
    ],
    tabStops: [
      {
        type: TabStopType.RIGHT,
        position: TabStopPosition.MAX,
        leader: "underscore",
        bold: true,
      },
    ],
  });
};
